<template>
  <div class="bake" @click="showDescription = !showDescription">
    <div
      class="background-image"
      v-for="pic in pics"
      :key="pic"
      :style="{ backgroundImage: `url(${pic})`, zIndex: pic == currentPic ? 0 : -1 }"
    ></div>
    <h3>{{ bake.title }}</h3>
    <p v-html="bake.description" v-show="showDescription"></p>
    <font-awesome-icon :icon="bake.icon"></font-awesome-icon>
  </div>
</template>

<script>
export default {
  name: 'Bake',
  props: ['bake'],
  data() {
    return {
      showDescription: false,
      currentPic: ''
    }
  },
  computed: {
    pics() {
      return Object.values(this.bake.images)
    }
  },
  methods: {
    changePic() {
      this.currentPic = this.pics[Math.floor(Math.random() * this.pics.length)]
      setTimeout(() => {
        this.changePic()
      }, Math.floor(Math.random() * 5000) + 2000)
    }
  },
  mounted() {
    this.showDescription = this.bake.nsfw
    this.changePic()
  }
}
</script>

<style lang="less" scoped>
.bake {
  display: inline-block;
  margin: 1em;
  width: 300px;
  height: 300px;
  position: relative;

  .background-image {
    background-position: center center;
    background-size: cover;
    border-radius: 7px;
    top: 0;
    position: absolute;
    height: 300px;
    width: 300px;
  }

  h3 {
    background-color: rgba(57, 120, 132, 0.8);
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
    bottom: 0;
    margin: 0;
    color: white;
    left: 0;
    line-height: 2em;
    position: absolute;
    right: 0;
  }

  p {
    background-color: rgba(255, 255, 255, 0.9);
    bottom: 2.5em;
    margin: 0;
    color: #333;
    font-size: 15px;
    font-style: italic;
    left: 0;
    padding: 1em;
    position: absolute;
    right: 0;
    top: 0;
  }

  svg {
    background-color: #3f0c70;
    border-radius: 7px;
    color: white;
    font-size: 1.5em;
    position: absolute;
    right: -0.5em;
    top: -0.5em;
    width: 0.75em;
    height: 0.75em;
    padding: 7px;
    border: 3px solid white;
  }
}

@media (max-width: 380px) {
  .bake {
    width: 260px;
    height: 260px;

    .background-image {
      background-position: center center;
      background-size: cover;
      width: 260px;
      height: 260px;
    }
  }
}
</style>
